import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const useAppBarStyles = makeStyles({
    root: {
        display: 'inline-flex',
        width: 'auto',
        borderRadius: 10,
        boxShadow: 'none',
        backgroundColor: '#fff',
    },
});

const useTabsStyles = makeStyles({
    root: {
        width: 'auto',
        minHeight: 44,
        flex: '0 0 auto',
    },
});

const useTabItemStyles = makeStyles((theme: Theme) => ({
    root: {
        // ✅ 모바일에서 한 탭이 100% 차지하지 않도록
        minWidth: 0,
        width: 'auto',
        flex: '0 0 auto',
        color: '#888',
        textTransform: 'none',
        '&$selected': {
            color: '#3280ff',
            fontWeight: 600,
        },
        // 데스크톱에선 약간 넓게(선택)
        [theme.breakpoints.up('sm')]: {
            minWidth: 120,
        },
    },
    selected: {},
}));

const useContainerStyles = makeStyles({
    root: {
        width: '100%',
        backgroundColor: '#f5f5f5',
    },
});

export function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            className="tab_contents"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
            style={{
                marginTop: '10px',
                backgroundColor: '#fff',
                borderRadius: '10px',
                maxHeight: 'calc(100vh - 170px)',
                overflow: 'auto',
            }}
        >
            {value === index && (
                <Box style={{
                    border: 'none',
                    display: 'inline-block',
                    width: '100%',
                    padding: 0
                }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

interface ScrollableTabs {
    labels: string[];
    children?: React.ReactNode[];
}

export function ScrollableTabsButtonAuto(props: ScrollableTabs) {
    const { labels, children = [] } = props;
    const container = useContainerStyles();
    const appBar = useAppBarStyles();
    const tabsCls = useTabsStyles();
    const tabItem = useTabItemStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (_e: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };


    return (
        <div className={container.root}>
            <AppBar position="static" classes={{ root: appBar.root }}>
                <Tabs
                    classes={{ root: tabsCls.root }}
                    value={value}
                    onChange={handleChange}
                    textColor="inherit"
                    TabIndicatorProps={{style: {backgroundColor: '#3280ff'}}}
                    variant="scrollable"           // ✅ 항상 스크롤형
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                >
                    {labels.map((label, index) => (
                        <Tab
                            key={index}
                            label={label}
                            classes={{root: tabItem.root, selected: tabItem.selected}}
                        />
                    ))}
                </Tabs>
            </AppBar>

            {children.map((child, index) => (
                <TabPanel key={index} value={value} index={index}>
                    {child}
                </TabPanel>
            ))}
        </div>
    );
}
